import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate, formatTime } from '@utils/format';
import { OrderDetailManagementTable } from '@components/templates/myAccount/manageOrderDetail/OrderDetailManagementTable';
import { OrderLog } from '@types';

interface OrderHistoryTableProps {
    logs: OrderLog[];
    showViewModal: (id: string) => void;
}

export const OrderHistoryTable: FC<OrderHistoryTableProps> = ({ logs, showViewModal }) => {
    const { t } = useTranslation();

    const translations = {
        date: t('history-table-component.header.date'),
        notes: t('history-table-component.header.notes'),
        amount: t('history-table-component.header.amount'),
        store: t('history-table-component.header.store'),
    };

    return (
        <OrderDetailManagementTable
            header={[
                { text: translations.date },
                { hideOnMobile: true, text: translations.notes },
                { classes: 'text-end', hideOnMobile: true, text: translations.amount },
                { hideOnMobile: true, text: translations.store },
            ]}
            content={logs.map((log) => {
                return {
                    cells: [
                        {
                            content: (
                                <>
                                    {formatDate(log.date)} <span className="text-muted ms-2">({formatTime(log.date)})</span>
                                </>
                            ),
                        },
                        { content: log.notes, acceptsHTML: true },
                        { classes: 'text-end', content: log.amount || '' },
                        { content: log.store || '' },
                    ],
                    options: [
                        {
                            icon: 'fa-light fa-eye',
                            action: () => showViewModal(log.id),
                        },
                    ],
                };
            })}
            hideActionsOnDesktop={true}
        />
    );
};
